import {useState, useEffect,useMemo } from 'react';
import { useSelector,useDispatch } from 'react-redux';
import styles from './ProductMenu.module.css';
import { uiActions, visualizerActions } from "../../store";
import FlooringMenu from "../FlooringMenu/FlooringMenu";
import WallBaseMenu from "../WallBaseMenu/WallBaseMenu";
import WallColorMenu from "../WallColorMenu/WallColorMenu";

export default function ProductMenu({ handleCompareToggle }) {

    const dispatch = useDispatch();
    
    const compareData = useSelector(state => state.visualizer.compareData);
    const vizLoading = useSelector(state => state.ui.vizLoading);
    const activeMenuTab = useSelector(state => state.visualizer.activeProductMenuTab);
    const surfaces = useSelector(state => state.visualizer.surfaceList);
    const activeSurface = useSelector(state => state.visualizer.activeSurface);

    const hasWallSurfaces = useMemo(
      () => Array.isArray(surfaces) && surfaces.some(s => /wall/i.test(s?.name ?? "")),
      [surfaces]
    );

    
    const handleMenuTabSelect = (menuTab) => () => {
        dispatch(visualizerActions.clearProductDropdownFilters([]));
        dispatch(visualizerActions.setActiveProductMenuTab(menuTab));

        //attempts to auto selects a wall surface
        if(hasWallSurfaces && menuTab.toLowerCase().includes('wall') && !activeSurface.name.toLowerCase().includes('wall')){
          surfaces.forEach((surface, index) => {
            if(surface.name.toLowerCase().includes('wall')){
              dispatch(visualizerActions.setActiveSurface(surfaces[index]));
              return false;
            }
          });
        }


        //attempts to auto selects a floor surface by assuming index 0 is always a floor type
        if(!menuTab.toLowerCase().includes('wall') && activeSurface.name.toLowerCase().includes('wall')){
          dispatch(visualizerActions.setActiveSurface(surfaces[0]));
        }
    };

  const renderActiveMenuTab = () => {
    switch (activeMenuTab) {
      case 'flooring':
        return (
          <FlooringMenu/>
        );
      case 'wall base':
        return (
          <WallBaseMenu/>
        );

      case 'wall color':
        return (
           <WallColorMenu/>
        );

      default:
        return null;
    }
  };

  return (
    <section className={styles.productMenu}>
      <div className={styles.content}>
        <ul className={styles.prodDiv}>
            <li onClick={handleMenuTabSelect('flooring')} className={activeMenuTab==='flooring' ? styles.activeMenuTab : '' }> Flooring </li>
           {hasWallSurfaces && (
            <>
              {/* <li onClick={handleMenuTabSelect('wall base')} className={activeMenuTab==='wall base' ? styles.activeMenuTab : '' }> Wall Base </li> */}
              <li onClick={handleMenuTabSelect('wall color')} className={activeMenuTab==='wall color' ? styles.activeMenuTab : '' }> Wall Color </li>
            </>
           )}
        </ul>

        {renderActiveMenuTab()}

        {/* <button type="button" onClick={handleCompareToggle}>
          {compareData.active ? 'Close Compare' : 'Compare'}
        </button> */}
      </div>
    </section>
  );
}


